























































































































































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  BibliographyRealDetailBibliography,
  SimpleBibliographyReal
} from '@/api'
import { CollectionFlag, Prefix } from '@/types'
import IconBibliography from '@/components/molecules/IconBibliography/IconBibliography.vue'
import { Emit } from '@/node_modules/nuxt-property-decorator'
@Component({
  components: { IconBibliography }
})
export default class BibliographyRealInfoMagazine extends ComponentVue {
  @Prop({
    type: Object,
    required: true
  })
  input!: BibliographyRealDetailBibliography | SimpleBibliographyReal

  @Prop({
    type: Boolean,
    default: false
  })
  linkable!: boolean

  get displayBibliographyId() {
    return (
      this.input.prefix + this.input.bibliographyId.toString().padStart(10, '0')
    )
  }

  get displayBibliographySetId() {
    if (this.input.bibliographySetId === null) {
      return ''
    }
    return (
      Prefix.Set + this.input.bibliographySetId.toString().padStart(10, '0')
    )
  }

  isCollectionFlagCollection(collectionFlag: CollectionFlag): boolean {
    return collectionFlag === CollectionFlag.Collection
  }

  @Emit('link')
  onClickLink(): void {}
}
